import { render, staticRenderFns } from "./UsersCollection.vue?vue&type=template&id=4a688d0c&"
import script from "./UsersCollection.vue?vue&type=script&lang=js&"
export * from "./UsersCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports